export default __webpack_public_path__ + "static/media/PayoutAssurance.83160c59.pdf";